import { render } from "./SubscribeModal.vue?vue&type=template&id=1aa8a966&scoped=true"
import script from "./SubscribeModal.vue?vue&type=script&lang=js"
export * from "./SubscribeModal.vue?vue&type=script&lang=js"

import "./SubscribeModal.vue?vue&type=style&index=0&id=1aa8a966&scoped=true&lang=css"

import exportComponent from "D:\\TeamCity\\BuildAgent2\\work\\1bfd74eb4d5fb108\\FamilyPortalApp\\familyportal-app\\src\\familyportal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa8a966"]])

export default __exports__